import { Capabilities, Channel, ComponentId, MenuItemId } from '@/models/channelModels';
import { CompanyAccount } from '@/models/companyModels';

const ALL_COMPONENTS: ComponentId[] = [
  'header',
  'sidebar',
  'profile_dropdown',
  'rewards_v3',
  'dashboard',
  'hamburger',
  'sidebar_custom_tabs',
  'loyalty_badges',
  'campaign_banner',
  'sidebar_profile_image',
  'sidebar_joined_date',
  'sidebar_full_name',
  'sidebar_point_system',
  'sidebar_referred_by',
];

const defaultCaps: Capabilities = {
  allowedComponents: new Set<ComponentId>(ALL_COMPONENTS),
  allowedRoutes: [/^\/.*/],
  allowCustomSidebarTabs: true,
  profileMenu: { profile: 'inherit', customTabs: 'inherit' },
  gates: new Set<string>([
    'sidebar_profile_image',
    'sidebar_joined_date',
    'sidebar_full_name',
    'sidebar_point_system',
    'sidebar_referred_by',
  ]),
  featureFlags: new Set<string>(),
};

function storefrontBaseCaps(): Capabilities {
  return {
    allowedComponents: new Set<ComponentId>(['header', 'profile_dropdown', 'rewards_v3']),
    allowedRoutes: [
      /^\/storefront(\/.*)?$/,
      /^\/app\/rewards\/v3(\/.*)?$/,
      /^\/app\/transactions(\/.*)?$/,
      /^\/app\/activity-portal(\/.*)?$/,
    ],
    allowedMenuItems: new Set<MenuItemId>(['rewards', 'transactions', 'activity']),
    allowCustomSidebarTabs: false,
    profileMenu: { profile: 'hide', customTabs: 'hide' },
    gates: new Set<string>([]), // no gates by default
    featureFlags: new Set<string>(['obfuscate_email']),
  };
}

export function getCapabilities(channel: Channel, company?: CompanyAccount | null): Capabilities {
  if (channel !== Channel.STOREFRONT) return defaultCaps;

  const caps = storefrontBaseCaps();

  // checks admin3 access to adjust feature capabilities
  if (!company?.portal_v3_access) {
    caps.allowedMenuItems?.delete('transactions');
    caps.allowedRoutes = caps.allowedRoutes.filter((r) => !String(r).includes('/app/transactions'));
    caps.allowedComponents.delete('rewards_v3');
    caps.allowedRoutes = caps.allowedRoutes.filter((r) => !String(r).includes('/app/rewards/v3'));
  } else {
    caps.allowedMenuItems?.delete('activity');
    caps.allowedRoutes = caps.allowedRoutes.filter((r) => !String(r).includes('/app/activity-portal'));
  }

  return caps;
}
